import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { FrameworkSkillSuggestionsResponse } from '../../entities/skills-framework.model';
import { DashboardApiService } from '../db-api.service';

interface SkillSuggestionsRequestData {
  skill_framework_version_id: number;
  course_description: string;
  group_id?: number;
}

@Injectable({
  providedIn: 'root',
})
export class SkillSuggestionsApiService extends DashboardApiService {
  readonly API_URL_SKILL_SUGGESTIONS = `/v1/issuer/organizations/${this.embedding.departmentId}/skill_suggestions`;

  getFrameworkSuggestedSkills(
    frameworkVersionId: number,
    courseDescription: string,
    groupId?: number,
  ): Observable<FrameworkSkillSuggestionsResponse> {
    const data: SkillSuggestionsRequestData = {
      skill_framework_version_id: frameworkVersionId,
      course_description: courseDescription,
    };

    if (groupId) {
      data.group_id = groupId;
    }

    return this._post(this.API_URL_SKILL_SUGGESTIONS, data).pipe(
      map((res) => this._handleResponse(res)),
      catchError((res) => this._handleError(res)),
    );
  }
}
